import { LoaderCircle, ShieldCheck } from "lucide-react";

import { cn } from "../../lib/utils";

export function MFAOpeningState({
  className,
  description,
  title,
}: {
  className?: string;
  description: string;
  title: string;
}) {
  return (
    <div
      aria-busy="true"
      className={cn(
        "flex min-h-32 items-center gap-4 rounded-2xl border border-primary/15 bg-primary/5 px-4 py-5",
        className,
      )}
      role="status"
    >
      <div className="relative flex h-12 w-12 shrink-0 items-center justify-center">
        <span
          aria-hidden="true"
          className="absolute inset-0 rounded-full bg-primary/10 animate-ping motion-reduce:animate-none"
        />
        <span className="relative flex h-11 w-11 items-center justify-center rounded-full bg-background text-primary shadow-sm ring-1 ring-primary/15">
          <ShieldCheck className="h-5 w-5" />
        </span>
      </div>
      <div className="min-w-0 space-y-1">
        <p className="flex items-center gap-2 text-sm font-semibold text-foreground">
          <LoaderCircle className="h-4 w-4 animate-spin text-primary motion-reduce:animate-none" />
          {title}
        </p>
        <p className="text-sm leading-6 text-muted-foreground">
          {description}
        </p>
      </div>
    </div>
  );
}
